import { render, staticRenderFns } from "./pre-page.vue?vue&type=template&id=147a268b&scoped=true"
import script from "./pre-page.vue?vue&type=script&lang=js"
export * from "./pre-page.vue?vue&type=script&lang=js"
import style0 from "./pre-page.vue?vue&type=style&index=0&id=147a268b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147a268b",
  null
  
)

export default component.exports